module.exports = __webpack_public_path__ + "6179f7621d9cd211ea702dd0a32d789d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-semibolditalic/opensans-semibolditalic.woff
// module id = ./src/styles/fonts/opensans-semibolditalic/opensans-semibolditalic.woff
// module chunks = index